module.exports = __webpack_public_path__ + "static/media/slide-1.f94fdb10.jpg";